import { Row, Col } from 'src/componentes/grid';

import { capitalizeFirstLetter } from 'src/utils/string';
import Input from 'src/componentes/input';
import DatePicker from 'src/componentes/date-picker';
import CollapsibleSection from 'src/componentes/CollapsibleSection';
import { COLABORADOR_CAMPOS } from 'src/utils/constants';

import { hasSearchMatch } from './searchUtils';

const ExtracurricularesSection = ({ model, resources, intl, campos, searchQuery }) => {
  if (!campos[COLABORADOR_CAMPOS.CURSO_EXTRACURRICULAR]) return null;

  const fieldMatches = (terms) => hasSearchMatch(searchQuery, terms);
  const sectionTerms = [
    capitalizeFirstLetter(resources?.cursosextracurriculares),
    intl.formatMessage({ id: 'cursoExtracurricular' }),
    intl.formatMessage({ id: 'instituicaoExtracurricular' }),
    intl.formatMessage({ id: 'dataConclusao' }),
  ];

  if (!hasSearchMatch(searchQuery, sectionTerms)) return null;

  return (
    <CollapsibleSection title={capitalizeFirstLetter(resources.cursosextracurriculares)}>
      <Row>
        {fieldMatches([intl.formatMessage({ id: 'cursoExtracurricular' })]) && (
          <Col md={12}>
            <Input model={model.getModel('cursoExtracurricular')} />
          </Col>
        )}
        {fieldMatches([intl.formatMessage({ id: 'instituicaoExtracurricular' })]) && (
          <Col md={12}>
            <Input model={model.getModel('instituicaoExtracurricular')} />
          </Col>
        )}
        {fieldMatches([intl.formatMessage({ id: 'dataConclusao' })]) && (
          <Col md={12}>
            <DatePicker
              timeFormat={false}
              model={{
                label: intl.formatMessage({ id: 'dataConclusao' }),
                value: model.getModel('dataConclusaoExtracurricular').value,
                requestChange: model.getModel('dataConclusaoExtracurricular').requestChange,
                errors: model.getModel('dataConclusaoExtracurricular').errors,
              }}
            />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
};

export default ExtracurricularesSection;
